import React, { useState } from "react";
import axios from "axios";

const FileUploader: React.FC = () => {
  const host = window.location.hostname;
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (file) {
      // Handle file upload logic here
      console.log("Uploading file:", file.name);

      const formData = new FormData();
      formData.append("file", file);

      let daemonBaseUrl;

      if (host.indexOf("localhost") !== -1) {
        daemonBaseUrl = "http://localhost:3002/api";
      } else {
        daemonBaseUrl =
          host.indexOf("stage") !== -1
            ? "https://daemon-stage.walletallin.com/api"
            : "https://daemon.walletallin.com/api";
      }

      axios
        .post(`${daemonBaseUrl}/uploader/upload-document`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-app-id": "84dfb176-eff3-11ed-a05b-0242ac120003",
          },
          withCredentials: true,
        })
        .then((response) => {
          console.log("File uploaded successfully:", response.data);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    }
  };

  return (
    <div>
      <p>{process.env.REACT_APP_API_BASE_HREF}</p>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload} disabled={!file}>
        Upload
      </button>
    </div>
  );
};

export default FileUploader;
